<template>
  <div class="content">
    <quill
      ref="quill"
      v-model="form.quillContent"
      :config="quilConfig"
      class="quill"
    />
    <v-input
      v-if="limit"
      :messages="messages"
      :error="error"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'AgrialRichTextEditor',
  props: {
    value: {
      type: String,
      default: null
    },
    limit: {
      type: Number,
      default: null
    },
    placeholderValue: {
      type: String,
      default: null
    }
  },
  data: () => ({
    quilConfig: {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'link']
        ]
      }
    },
    form: {
      quillContent: null
    }
  }),
  computed: {
    quillEditor () {
      return this.$refs.quill._data.editor
    },
    nbChar () {
      return this.value ? this.value.length : 0
    },
    error () {
      return this.limit && this.nbChar > this.limit
    },
    messages () {
      if (this.limit) {
        if (this.nbChar < this.limit) {
          return `${this.nbChar}/${this.limit}`
        } else {
          return `Maximum de caractères atteint : ${this.nbChar}/${this.limit}`
        }
      }
      return null
    }
  },
  watch: {
    'form.quillContent': {
      handler () {
        this.updateValue()
      },
      deep: true
    },
    value (oldVal, newVal) {
      // eslint-disable-next-line eqeqeq
      if (oldVal !== newVal) {
        this.updateInnerValue()
      }
    }
  },
  created () {
    this.quilConfig.placeholder = this.placeholderValue
  },
  mounted () {
    this.updateInnerValue()
    this.quillEditor.root.setAttribute('spellcheck', 'true')
  },
  methods: {
    getHtml () {
      if (this.$refs.quill) {
        return this.quillEditor.root.innerHTML
      }
      return ''
    },
    applyLimit () {
      this.quillEditor.deleteText(this.limit, this.quillEditor.getLength())
      let i = 0
      while (this.getHtml().length > this.limit) {
        this.quillEditor.deleteText(this.quillEditor.getLength() - 2, 1)
        if (i++ > 1000000) {
          // security
          break
        }
      }
    },
    updateInnerValue () {
      // eslint-disable-next-line eqeqeq
      if (this.value !== this.getHtml()) {
        const delta = this.quillEditor.clipboard.convert(this.value)
        this.quillEditor.setContents(delta, 'silent')
      }
    },
    updateValue () {
      let html = this.getHtml()
      if (html === '<p><br></p>' || !html) {
        html = null
      }

      if (html && this.limit && html.length > this.limit) {
        this.applyLimit()
      }

      this.$emit('input', html)
    }
  }
})
</script>

<style lang="scss" scoped>
.content {
  max-height: 30vh;
}

.quill {
  height: 170px;
  display: flex;
  flex-direction: column;
}

::v-deep {
  .ql-tooltip {
    z-index: 1000;
    left: 30% !important;
  }

  .ql-editing {
    left: 30% !important;
  }

  .ql-container {
    overflow-y: hidden;
    flex: 1;
    padding-bottom: 5px;
  }
}
</style>
